<template>
  <div>
    <el-row class="tree-content" type="flex" :gutter="20">
      <el-col :span="10">
        <div class="bbaff">
          <div class="tree-panel">
            <div class="tree-title cle">
              <p class="title">{{$t('system_role.role_list')}}</p>
              <div class="fr">
                <el-button type="primary" v-if="hasBtn('add')" size="mini" @click="add('')">{{$t('index.add')}}</el-button>
              </div>
            </div>
            <div class="tree-list">
              <el-table size="mini" :data="tableData" border style="width: 100%;margin-bottom: 20px;" row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column :prop="lang=='cn'?'name_cn':'name'" :label="$t('system_role.name')" align="center"></el-table-column>
                <el-table-column prop="name" :label="$t('index.operation')" align="center" width="290">
                  <template slot-scope="scope">
                    <el-button type="primary" size="mini" v-if="hasBtn('edit')" @click="add(scope.row,scope.$index)">{{$t('index.edit')}}</el-button>
                    <el-button type="info" size="mini" v-if="hasBtn('del')" @click="del(scope.row,scope.$index)">{{$t('index.del')}}</el-button>
                    <el-button type="primary" size="mini" v-if="hasBtn('authorization')" @click="empower(scope.row,scope.$index)">{{$t('system_role.authorize')}}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="14">
        <div class="bbaff">
          <div class="tree-panel">
            <div class="tree-title cle">
              <p class="title">{{lang=='cn'?role_name.name_cn:role_name.name}}{{$t('system_role.role_authorize')}}</p>
              <div class="fr">
                <el-button type="primary" size="mini" v-if="hasBtn('preservation')" @click="powerkeep">{{$t('index.preservation')}}</el-button>
              </div>
            </div>
          </div>
          <div class="filter-inline-panel">
            <el-row class="tree-content" type="flex" :gutter="20">
              <el-col :span="12">
                <p v-if="listData.length==0">{{$t('system_role.select_authorize')}}</p>
                <div v-if="listData.length>0" >
	                <el-tree ref="tree0" :default-checked-keys="menu_ids" :check-strictly="true" :default-expand-all="true" :data="listData" show-checkbox node-key="id" :props="defaultProps"></el-tree>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="$t('index.dialog_title')" width="800px"  :close-on-click-modal="false" :visible="dialog" @close="dialog = false">
      <el-form :model="editForm" size="mini" label-width="70px" label-position="top" :rules="editFormRules" ref="editForm">
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('index.cn')+this.$t('system_role.name')" prop="name_cn">
              <el-input v-model="editForm.name_cn" :placeholder="$t('index.input')" class="w100" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.en')+this.$t('system_role.name')" prop="name">
              <el-input v-model="editForm.name" :placeholder="$t('index.input')" class="w100" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
			<el-col :span="12">
				<el-form-item :label="$t('system_role.show_message')" prop="show_message">
					<el-select v-model="editForm.show_message" class="w100" :placeholder="$t('index.select')">
						<el-option :label="lang=='cn'?item.name_cn:item.name" :value="index" v-for="(item,index) in show_message" :key="index"></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item :label="$t('system_role.show_kickback')" prop="show_kickback">
					<el-select v-model="editForm.show_kickback" class="w100" :placeholder="$t('index.select')">
						<el-option :label="lang=='cn'?item.name_cn:item.name" :value="index" v-for="(item,index) in show_message" :key="index"></el-option>
					</el-select>
				</el-form-item>
			</el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="dialog = false">{{$t('index.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
	computed: {
		editFormRules(){
			return{
				name_cn: [{
					required: true,
					message: this.$t('index.input')+this.$t('index.cn')+this.$t('system_role.name'),
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: this.$t('index.input')+this.$t('index.en')+this.$t('system_role.name'),
					trigger: 'blur'
				}],
			}
		},
	},
	data() {
		return {
			defaultProps:{
				children: 'children',
				label: this.lang=='cn'?'name_cn':'name',
				value: 'id',
				checkStrictly: true
			},
			dialog: false,
			editForm: {
				name: '',
				name_cn: '',
			},
			tableData: [],
			role_id: '',
			role_name: '',
			menu_ids: [],
			listData:[],
			show_message: [
				{
					name_cn:'否',
					name:'NO',
				},
				{
					name_cn:'是',
					name:'YES',
				},
			], 

		}
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	// 事件
	methods: {
		// 初始化角色列表
		init: function () {
			var this_ = this;
			var url = "roleList";
			var datas = {};
			this_.$post(url, datas).then((res) => {
				this_.tableData = res;
			})
		},
		add(data, index) {
			if (data) {
				this.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this.editForm = {
					name: '',
					name_cn: '',
					show_message:0,
					show_kickback:0,
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.dialog = true;
		},
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var url = "roleAction";
					var datas = {
						name: this_.editForm.name,
						name_cn: this_.editForm.name_cn,
						show_message: this_.editForm.show_message,
						show_kickback: this_.editForm.show_kickback,
					}
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id
						tishi = this_.$t('index.modify_success');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.dialog = false;
						this_.init();
					});
				} else {
					return false;
				}
			});
		},
		del(data, index) {
			var this_ = this;
			var url = "roleDelete";
			var datas = {
				id: data.id
			}
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		empower(data, index) {
			var this_ = this;
			var url = "empowerIndex";
			this_.role_id = data.id;
			this_.role_name = data;
			var datas = {
				id: data.id,
			};
			this_.$post(url, datas).then((res) => {
				this_.listData = res.all_menu;
				this_.menu_ids = res.menu_ids;
			})
		},
		// 授权保存
		powerkeep() {
			var this_ = this;
			var url = "roleEmpower";
			var ref=this.$refs.tree0;
			if (ref) {
				var menu_set_ids = ref.getCheckedKeys();
				var menu_ids=menu_set_ids.length > 0 ? menu_set_ids.join(',') : '';
				if (menu_ids) {
					var datas = {
						role_id: this_.role_id,
						menu_ids:menu_ids,
					};
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.modify_success'));
					})
				}
			}
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.w100 {
	width: 100%;
}
.pingweibuyao {
	position: absolute;
	left: -142px;
	top: 0;
	width: 1px;
	opacity: 0;
}
.bbaff {
	background: #fff;
	min-height: 100%;
	padding: 25px 30px;
}
.filter-panel {
	display: inline-block;
	width: 80%;
	vertical-align: top;
}
.list-opinion {
	display: inline-block;
	width: 18%;
	text-align: right;
	vertical-align: top;
}
.list-btn-group {
	margin: 0;
}
.list-btn-group a {
	color: #1890FF;
	cursor: pointer;
	margin: 0 5px;
}
.dialog-bottom-btn {
	text-align: center;
}
.mab_20 {
	margin-bottom: 20px;
}
.tree-panel {
	background: #ffffff;
	height: 100%;
}
.tree-panel .tree-list {
	/* padding: 0 15px; */
}
.tree-panel .tree-title {
	padding-bottom: 10px;
	border-bottom: 1px solid #F5F5F5;
	margin-bottom: 20px;
}
.tree-panel .tree-title .title .opinion {
	float: right;
}
.tree-panel .tree-title .title {
	/* width: 60px; */
	float: left;
}
.tree-panel .tree-title .opinion {
	float: right;
}
.tree-panel .tree-title .opinion i {
	margin: 0 5px;
	font-size: 20px;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/system/role.vue